export default {
  title: 'Żądaj usunięcia danych dla {{name}}',
  description:
    'Tworzy żądanie usunięcia danych RODO. Administrator musi je zatwierdzić, zanim dane klienta zostaną trwale usunięte.',
  form: {
    note: {
      label: 'Uwaga',
      placeholder: 'Dodaj kontekst do tego żądania (opcjonalnie)',
    },
  },
  buttons: {
    confirm: 'Żądaj usunięcia',
  },
  toasts: {
    success: 'Żądanie usunięcia danych zostało utworzone',
    error: 'Nie udało się utworzyć żądania usunięcia danych',
  },
};
